import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, CustomerOrders } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/orders',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<CustomerOrders>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchOrders (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.fetchOrders()
      const { data } = response || {}
      const { customerOrders } = data || {}

      if (customerOrders) {
        dispatch(success(customerOrders))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
